import type { RequestType } from '../../types';

export interface SupportCategory {
  key: string;            // drawer item key / route name
  requestType: RequestType;
  route: string;          // SupportStack screen name
  titleKey: string;       // i18n key for list title
  addLabelKey: string;    // i18n key for the add button
}

export const SUPPORT_CATEGORIES: SupportCategory[] = [
  { key: 'SupportInquiries', requestType: 'inquiry',   route: 'SupportInquiries', titleKey: 'support.inquiries.title',  addLabelKey: 'support.inquiries.add' },
  { key: 'SupportRemarks',   requestType: 'remark',    route: 'SupportRemarks',   titleKey: 'support.remarks.title',    addLabelKey: 'support.remarks.add' },
  { key: 'SupportComplaints',requestType: 'complaint', route: 'SupportComplaints',titleKey: 'support.complaints.title', addLabelKey: 'support.complaints.add' },
  { key: 'SupportStrategic', requestType: 'strategic', route: 'SupportStrategic', titleKey: 'support.strategic.title',  addLabelKey: 'support.strategic.add' },
  { key: 'SupportTechnical', requestType: 'technical', route: 'SupportTechnical', titleKey: 'support.technical.title',  addLabelKey: 'support.technical.add' },
  { key: 'SupportChange',    requestType: 'change',    route: 'SupportChange',    titleKey: 'support.change.title',     addLabelKey: 'support.change.add' },
];
